<template>
    <ModalBase v-if="visible" :with-content="true" @close="cancel">
        <h1>Edit Fixing</h1>
        <section>
            <label sm="4"> <label>Fixed:</label> </label> <label sm="8"> <b-form-checkbox v-model="fixed"></b-form-checkbox> </label>
        </section>
        <section>
            <label sm="4"> <label>X:</label> </label> <label sm="8"> <NumberInput v-model="x"></NumberInput> </label>
        </section>
        <section>
            <label sm="4"> <label>Y:</label> </label> <label sm="8"> <NumberInput v-model="y"></NumberInput> </label>
        </section>

        <footer>
            <ClientColorButton @click="validate">{{ $trad.common.ok }}</ClientColorButton>
            <ClientColorButton @click="cancel">{{ $trad.common.cancel }}</ClientColorButton>
        </footer>
    </ModalBase>
</template>

<script>
import { Context } from "plano_engine";
import NumberInput from "../components/number-input";
import ModalBase from "@/components/modal/ModalBase";
import ClientColorButton from "@/components/ui/ClientColorButton";

let editBoardFixingWidget;
window.editBoardFixing = function editBoardFixing(data, onValidate, onCancel) {
    const parent = data.element.parent();

    editBoardFixingWidget.setElement(data.element);
    editBoardFixingWidget.fixed = data.fixed;

    editBoardFixingWidget.x = data.x + parent.width / 2 / Context.rescaleFactor;
    editBoardFixingWidget.y = -data.y + parent.height / 2 / Context.rescaleFactor;
    editBoardFixingWidget.visible = true;
    editBoardFixingWidget.onValidate = onValidate;
    editBoardFixingWidget.onCancel = onCancel;
};

function preview() {
    if (this.element) {
        const parent = this.element.parent();
        this.element.update({
            x: parseFloat(this.x) - parent.width / 2 / Context.rescaleFactor,
            y: -parseFloat(this.y) + parent.height / 2 / Context.rescaleFactor,
            fixed: this.fixed
        });
    }
}

export default {
    components: {
        NumberInput,
        ModalBase,
        ClientColorButton
    },
    data() {
        return {
            x: 0,
            y: 0,
            fixed: false,
            visible: false,
            onValidate: undefined,
            onCancel: undefined
        };
    },
    watch: {
        x: preview,
        y: preview,
        fixed: preview
    },
    created() {
        editBoardFixingWidget = this;
    },
    methods: {
        setElement(value) {
            this.element = value;
            Context.memento.open();
        },
        validate() {
            const parent = this.element.parent();
            this.onValidate({
                x: parseFloat(this.x) - parent.width / 2 / Context.rescaleFactor,
                y: -parseFloat(this.y) + parent.height / 2 / Context.rescaleFactor,
                fixed: this.fixed
            });
            this.clear();
        },
        cancel() {
            this.onCancel();
            Context.memento.undo();
            this.clear();
        },
        clear() {
            this.element = undefined;
            this.x = 0;
            this.y = 0;
            this.fixed = false;
            this.visible = false;
            this.onValidate = undefined;
            this.onCancel = undefined;
        }
    }
};
</script>

<style lang="scss" scoped>
section {
    margin: 10px 0px;
}
</style>



// WEBPACK FOOTER //
// edit_board_fixing.vue?71d8fc84